import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "../../../axios/index";

import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// styles
import styles from "./signUp.module.css";

// img
import homeIcon from "../../../assets/img/HomePage/AzarMelk.svg";
import sideImg from "../../../assets/register.png";

const VerifySignUpCode = props => {
  const history = useHistory();
  const [signUpData, setSignUpData] = useState({
    code: "",
  });
  const [btnLoader, setBtnLoader] = useState(false);
  const [timer, setTimer] = useState(90);
  const [showResendButton, setShowResendButton] = useState(false);

  let estateId = props.estateId;
  let subject = props.subject;
  let resiverId = props.resiverId;

  console.log(estateId);

  const changeHandler = e => {
    setSignUpData(prev => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  // Remove Symbol From Input Number
  // const removeSymbolNumberHandler = (e) => {
  //     const removeSymbolNumber = ["e", "E", ".", "-"];

  //     if (removeSymbolNumber.includes(e.key)) {
  //         e.preventDefault();
  //     }
  // }

  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
    } else {
      setShowResendButton(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = time => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <div className="d-flex justify-content-center align-items-md-start align-items-center py-md-0 py-5 flex-column" dir="rtl">
        <div className="w-100 d-flex flex-md-row flex-column align-items-center justify-content-md-end justify-content-center">
          <Link to="/" className={`mt-4 mb-5 ${styles.logo_container}`} style={{ zIndex: "5" }}>
            <img src={homeIcon} alt="icon" />
          </Link>
          <form
            onSubmit={e => e.preventDefault()}
            className={`d-flex align-items-center justify-content-start pt-4 px-md-5 px-0 flex-column ${styles.form_container}`}>
            <h1 className={`mb-4 ${styles.form_title}`}>ثبت نام</h1>
            <div className="w-100 d-flex flex-column align-items-start justify-content-center position-relative mb-4 px-3">
              <h1 className={`mb-5 ${styles.form_title2}`}>ارسال کد</h1>
              <div className="w-100 d-flex flex-column align-items-start justify-content-center">
                <h6 className={styles.input_title}>کد دریافتی را وارد کنید</h6>
                <input className={styles.form_input} type="number" name="code" value={signUpData.code} onChange={changeHandler} />
              </div>
              <div className={styles.countdoown_container}>
                {showResendButton ? (
                  <button className={`ms-1 mb-0 ${styles.countdoown_text}`} type="button" onClick={resendOTP}>
                    ارسال مجدد
                  </button>
                ) : (
                  <span className={styles.countdoown_number}>{e2p(formatTime(timer))}</span>
                )}
              </div>
            </div>
            {btnLoader ? (
              <div className={styles.btn_loader_container}>
                <div className={styles.btn_spinner}></div>
              </div>
            ) : (
              <div className="w-100 d-flex align-items-center justify-content-center">
                <button type="submit" className={styles.form_submit_btn} onClick={() => loginHandler(props.phone, signUpData.code)}>
                  ثبت نام
                </button>
              </div>
            )}
          </form>
          <div className={styles.side_img}>
            <img src={sideImg} alt="img" />
          </div>
        </div>
      </div>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // postHandler()
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function createChat(userToken) {
    // console.log("Hello");
    notify("درحال ایجاد چت", "success");
    try {
      var data = new FormData();
      data.append("RecieverId", resiverId);
      data.append("EstateId", estateId);
      data.append("Subject", subject);
      const apiData = await axios.post("Messages/CreateMessage", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // if (apiData.data.isSuccess) {
      history.push("/chats");
      // }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function loginHandler(phone, code) {
    setBtnLoader(true);
    try {
      var data = {
        phoneNumber: phone,
        code: code,
      };

      const apiData = await axios.post("Auth/ActivationAccount", data);

      // setUserData(apiData.data.data.token)
      localStorage.setItem("userToken", apiData.data.data.token);
      // console.log(apiData)
      if (apiData.data.data.token) {
        const getUsersData = await axios.get("Users/Current", {
          headers: { authorization: "Bearer " + apiData.data.data.token },
        });
        localStorage.setItem("userData", JSON.stringify(getUsersData.data.data));
      }

      if (estateId != null || estateId != undefined) {
        createChat(apiData.data.data.token);
        return;
      }
      notify("خوش آمدید", "success");
      setBtnLoader(false);
      history.push({
        pathname: "/",
        state: { success: true, message: "خوش آمدید" },
      });
      window.location.reload(false);
    } catch (error) {
      notify("کد تایید اشتباه است", "error");
    }
  }

  async function resendOTP() {
    notify("درحال ارسال کد تایید", "success");
    try {
      setBtnLoader(false);
      setTimer(90);
      setShowResendButton(false);

      var data = {
        name: props.name,
        family: props.lastName,
        phoneNumber: props.phone,
      };

      const apiData = await axios.post("Auth/register", data);

      notify(apiData.data.metaData.message, apiData.data.isSuccess ? "success" : "error");
      setBtnLoader(false);
    } catch (error) {
      notify("خطای سرور", "error");
      setBtnLoader(false);
    }
  }
};

export default VerifySignUpCode;
